import React from "react";
import {
  ShieldCheckIcon,
  TruckIcon,
  StarIcon
} from "@heroicons/react/24/outline";

const WhyChooseUs = () => {
  const features = [
    {
      icon: ShieldCheckIcon,
      title: "Verified Professionals",
      desc: "Background verified and highly trained experts for safe service."
    },
    {
      icon: TruckIcon,
      title: "On-Time Service",
      desc: "We respect your time. Our professionals arrive as scheduled."
    },
    {
      icon: StarIcon,
      title: "Top Rated Experience",
      desc: "Rated highly by thousands of satisfied customers."
    }
  ];

  return (
    <section className="overflow-hidden bg-white py-20 text-[#0D004C] sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-20">
          <div className="relative">
            <div className="absolute -left-6 top-1 h-24 w-px bg-[#AF7D23] sm:-left-8" />
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-[#AF7D23]">
              The Our Genie promise
            </p>
            <h2 className="max-w-md text-4xl font-semibold leading-[1.08] tracking-[-0.03em] text-[#0D004C] sm:text-5xl">
              Care that shows up.
            </h2>
            <p className="mt-6 max-w-md text-sm leading-7 text-gray-500 sm:text-base">
              From the first click to the finished job, every detail is designed around your peace of mind.
            </p>
            <div className="mt-8 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.18em] text-gray-400">
              <span className="h-px w-10 bg-[#AF7D23]" />
              Simple. Reliable. Human.
            </div>
          </div>

          <div className="divide-y divide-gray-200 border-y border-gray-200">
          {features.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="group grid gap-5 py-7 transition-colors duration-300 first:pt-0 last:pb-0 sm:grid-cols-[3rem_3.5rem_1fr] sm:items-center sm:gap-6"
              >
                <span className="text-sm font-semibold text-[#AF7D23]">0{index + 1}</span>
                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#AF7D23]/30 bg-[#fff8e8] transition duration-300 group-hover:border-[#AF7D23] group-hover:bg-[#AF7D23]">
                  <Icon className="h-6 w-6 text-[#AF7D23] transition group-hover:text-white" />
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-[#0D004C]">
                    {item.title}
                  </h3>
                  <p className="mt-2 max-w-lg text-sm leading-relaxed text-gray-500 transition-colors group-hover:text-gray-700">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
